<div class="bg-white">
  <div class="mx-auto overflow-hidden">
    <app-item-list-header></app-item-list-header>
    <app-filter-bar></app-filter-bar>

    @if (algolia.observeHits() | async; as hits) {
      <div class="grid auto-cols-fr gap-y-8 md:grid-cols-2 xl:grid-cols-3">
        @if (hits.length === 0 && algolia.getCurrentQuery()) {
          <div class="flex flex-col items-center justify-center h-64">
            <h2 class="text-2xl text-gray-800">{{ { key: 'noResult' } | i18n }}</h2>
            <p class="text-gray-600">{{ { key: 'noResultInfo' } | i18n }}</p>
          </div>
        } @else if (hits.length === 0) {
          <div style="height: 3000px"></div>
        } @else {
          @for (hit of hits; track hit.objectID; let i = $index) {
            <app-item-list-item [item]="hit" [index]="i"></app-item-list-item>
          }
        }
      </div>

      @if (algolia.observeTotalHitCount() | async; as totalCount) {
        <div class="flex flex-col items-center content-end mt-12">
          <div class="text-sm text-gray-700 h-4">
            {{ algolia.observeHitCount() | async }} {{ { key: 'of' } | i18n }}
            {{ totalCount }}
            {{ { key: 'entry' } | i18n }}
          </div>
          @if ((algolia.observeHitCount() | async) !== (algolia.observeTotalHitCount() | async)) {
            <button
              class="mt-4 mb-2 max-w-xs items-center justify-center rounded-md border border-transparent bg-primary-600 py-2 px-4 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
              (click)="algolia.loadNextPage()"
            >
              {{ { key: 'loadMore' } | i18n }}
            </button>
          }
        </div>
      }
    }
  </div>
</div>
